<template>
  <section class="counters">
    <MailCounters v-if="getCurrentProject === 'mailru'" />
    <MycomCounters v-if="getCurrentProject === 'mycom'" />
  </section>
</template>
<script>
import MailCounters from "./blocks/MailCounters.vue";
import MycomCounters from "./blocks/MycomCounters.vue";
export default {
  name: "WFCounters",

  components: {
    MailCounters,
    MycomCounters,
  },

  props: {
    territory: {
      type: String,
      requried: true,
    },
  },

  computed: {
    getCurrentProject() {
      return this.territory;
    },
  },
};
</script>
<style scoped>
.counters {
  display: none;
}
</style>
